const EXCHANGE_UNUSUAL_CODE = 8
const EXCHANGE_UNUSUAL_DESCRIPTION = '换货收货后转异常，待异常组安排换货发货'

const valueOrEmpty = value => value === undefined || value === null ? '' : String(value)

const resolveExchangeWaybill = (after, fallbackWaybill) => {
  const source = after || {}
  return valueOrEmpty(source.waybillId || source.afterSaleWaybillId || fallbackWaybill).trim()
}

const resolveExchangeTeamName = (vips, teamId) => {
  const source = Array.isArray(vips) ? vips : []
  const team = source.find(item => String(item.teamId) === String(teamId))
  return team ? valueOrEmpty(team.teamName) : valueOrEmpty(teamId)
}

const buildExchangeProductLines = items => {
  const source = Array.isArray(items) ? items : []
  const lines = source.map(item => {
    const current = item || {}
    const orderVo = current.orderVo || {}
    const productVo = current.productVo || {}
    const productSpecs = productVo.specs || {}
    const code = valueOrEmpty(orderVo.code || current.code).trim()
    const name = valueOrEmpty(productVo.name || orderVo.product_name || current.productName).trim()
    const specs = valueOrEmpty(productSpecs.name || orderVo.specs || current.specs).trim()
    const num = current.num === undefined || current.num === null ? 1 : current.num
    const main = code || name || '未识别商品'
    return `${main}${specs ? `｜${specs}` : ''} × ${num}`
  })
  return lines.filter((line, index) => lines.indexOf(line) === index)
}

const shouldPromptExchangeUnusual = (comment, unusualItems) => {
  return Number(comment) === 1 && !(Array.isArray(unusualItems) && unusualItems.length)
}

const isExistingUnusualConflict = error => {
  const message = error && error.message ? error.message : ''
  return message.indexOf('已转过异常') > -1
}

const exchangeUnusualFlow = {
  data() {
    return {
      exchangeUnusualFlowState: {},
      exchangeUnusualPendingNotice: null
    }
  },
  methods: {
    shouldPromptExchangeUnusual,

    buildExchangeUnusualContext(options) {
      const source = options || {}
      const after = source.after || {}
      const teamId = source.teamId || this.vipName
      const vips = this.vips || this.fromVips || []
      return {
        after,
        afterSaleId: valueOrEmpty(after.aftersaleId || source.afterSaleId),
        description: source.description || EXCHANGE_UNUSUAL_DESCRIPTION,
        items: Array.isArray(source.items) ? source.items : (after.items || []),
        shopName: valueOrEmpty(source.shopName || after.shopName),
        teamId,
        teamName: source.teamName || resolveExchangeTeamName(vips, teamId),
        waybillId: resolveExchangeWaybill(after, source.waybillId || this.afterWaybillId)
      }
    },

    buildExchangeUnusualMessage(context) {
      const h = this.$createElement
      const productLines = buildExchangeProductLines(context.items)
      const rows = [
        h('div', {
          style: {
            color: '#67C23A',
            fontWeight: 'bold',
            marginBottom: '8px'
          }
        }, '换货收货已成功'),
        h('div', `退回物流单号：${context.waybillId}`),
        h('div', `客户：${context.teamName || '-'}`),
        h('div', `店铺：${context.shopName || '-'}`),
        h('div', `售后单号：${context.afterSaleId || '-'}`)
      ]
      const visibleProducts = productLines.slice(0, 3)
      visibleProducts.forEach(line => rows.push(h('div', `商品：${line}`)))
      if (productLines.length > visibleProducts.length) {
        rows.push(h('div', `另有 ${productLines.length - visibleProducts.length} 项商品，请以当前售后明细为准`))
      }
      rows.push(h('div', {
        style: {
          color: '#E6A23C',
          fontWeight: 'bold',
          marginTop: '10px'
        }
      }, '确认后：登记为“换货”异常件，由异常组后续安排换货发货。'))
      rows.push(h('div', '本操作不会立即发货。'))
      return h('div', {style: {lineHeight: '1.8'}}, rows)
    },

    setExchangeUnusualState(waybillId, state) {
      this.$set(this.exchangeUnusualFlowState, waybillId, state)
    },

    closeExchangeUnusualPendingNotice() {
      if (this.exchangeUnusualPendingNotice && this.exchangeUnusualPendingNotice.close) {
        this.exchangeUnusualPendingNotice.close()
      }
      this.exchangeUnusualPendingNotice = null
    },

    markExchangeUnusualManualPending(context, message) {
      this.setExchangeUnusualState(context.waybillId, 'manual')
      this.unusual = EXCHANGE_UNUSUAL_CODE
      this.afterWaybillId = context.waybillId
      this.closeExchangeUnusualPendingNotice()
      this.exchangeUnusualPendingNotice = this.$message({
        type: 'warning',
        showClose: true,
        duration: 0,
        message: message || `换货收货已完成，但物流单 ${context.waybillId} 尚未转异常，请及时处理。`
      })
    },

    confirmExchangeUnusual(options) {
      const context = this.buildExchangeUnusualContext(options)
      if (!context.waybillId) {
        this.$alert(
            '换货收货已经成功，但未获取到退回物流单号，无法自动登记换货异常，请立即手工处理。',
            '换货尚未转异常',
            {type: 'warning'}
        )
        return Promise.resolve(false)
      }
      const state = this.exchangeUnusualFlowState[context.waybillId]
      if (state === 'success') {
        return Promise.resolve(true)
      }
      if (state === 'submitting') {
        return Promise.resolve(false)
      }
      return this.$confirm(
          this.buildExchangeUnusualMessage(context),
          '换货收货成功｜继续转异常',
          {
            confirmButtonText: '确认转异常',
            cancelButtonText: '暂不转异常',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            distinguishCancelAndClose: true,
            type: 'warning'
          }
      ).then(() => this.submitExchangeUnusualWithRetry(context)).catch(action => {
        if (action === 'cancel' || action === 'close') {
          this.markExchangeUnusualManualPending(context)
          return false
        }
        throw action
      })
    },

    submitExchangeUnusualWithRetry(context) {
      this.setExchangeUnusualState(context.waybillId, 'submitting')
      const loading = this.$loading({
        lock: true,
        text: '正在登记换货异常...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      return Promise.resolve().then(() => this.submitExchangeUnusualRecord(context)).then(() => {
        loading.close()
        this.setExchangeUnusualState(context.waybillId, 'success')
        this.closeExchangeUnusualPendingNotice()
        this.unusual = EXCHANGE_UNUSUAL_CODE
        if (this.afterWaybillId === context.waybillId) {
          this.afterWaybillId = null
        }
        this.$message.success(`【${context.waybillId}】已登记为换货异常件`)
        return true
      }).catch(error => {
        loading.close()
        this.setExchangeUnusualState(context.waybillId, 'failed')
        const errorMessage = error && error.message ? error.message : '未知错误'
        if (isExistingUnusualConflict(error)) {
          this.markExchangeUnusualManualPending(
              context,
              `换货收货已完成，但物流单 ${context.waybillId} 已有其他异常登记，请手工核对，系统未自动覆盖。`
          )
          return this.$alert(
              `换货收货已完成，但该包裹已有异常登记，系统未自动覆盖。请手工核对后处理。\n${errorMessage}`,
              '换货尚未转异常',
              {type: 'warning'}
          ).then(() => false)
        }
        return this.$confirm(
            `换货收货已经成功，但转异常失败：${errorMessage}`,
            '换货尚未转异常',
            {
              confirmButtonText: '重试转异常',
              cancelButtonText: '稍后手工处理',
              closeOnClickModal: false,
              closeOnPressEscape: false,
              distinguishCancelAndClose: true,
              type: 'error'
            }
        ).then(() => this.submitExchangeUnusualWithRetry(context)).catch(action => {
          if (action === 'cancel' || action === 'close') {
            this.markExchangeUnusualManualPending(context)
            return false
          }
          throw action
        })
      })
    }
  }
}

export {
  EXCHANGE_UNUSUAL_CODE,
  EXCHANGE_UNUSUAL_DESCRIPTION,
  buildExchangeProductLines,
  isExistingUnusualConflict,
  resolveExchangeTeamName,
  resolveExchangeWaybill,
  shouldPromptExchangeUnusual
}

export default exchangeUnusualFlow



// WEBPACK FOOTER //
// ./src/utils/exchangeUnusualFlow.js